export const elasticApmTags = {
  API_TRANSACTION: (data) => {
    const fields = data?.fields || {};
    let uuid = fields?.userInfo?.uuid;
    let username = fields?.userInfo?.username;
    if (process.env.NODE_ENV === 'development') {
      uuid = fields?.userInfo?.sub;
      // eslint-disable-next-line camelcase
      username = fields?.userInfo?.preferred_username;
    }
    return {
      event: 'api-transaction',
      data: {
        result: fields.code && fields.code === 200 ? 'success' : 'error',
        appVersion: process.env.PACKAGE_VERSION,
        url: window.location.href,
        uuid,
        ipAddress: fields?.userInfo?.ipAddress || '',
        optumId: username,
        username,
        status: fields.code,
        endpoint: fields.endpoint,
        method: fields.method,
        operationName: fields.operationName,
        message: fields.message,
      },
    };
  },
  API_TRANSACTION_ERROR: (data) => {
    const fields = data?.fields || {};
    let uuid = fields?.userInfo?.uuid;
    let username = fields?.userInfo?.username;
    if (process.env.NODE_ENV === 'development') {
      uuid = fields?.userInfo?.sub;
      // eslint-disable-next-line camelcase
      username = fields?.userInfo?.preferred_username;
    }
    return {
      event: 'api-transaction',
      data: {
        result: 'js error',
        appVersion: process.env.PACKAGE_VERSION,
        url: window.location.href,
        uuid,
        ipAddress: fields?.userInfo?.ipAddress || '',
        optumId: username,
        username,
        status: fields.code,
        endpoint: fields.endpoint,
        method: fields.method,
        operationName: fields.operationName,
        message: fields.message,
      },
    };
  },
};
